import connector from 'Utils/connector';
import { usageTrackSignupButtonTap } from 'Webapp/shared/app/redux/actions/usage-actions';
import SignupButton from 'Webapp/shared/app/components/signup-button';

export default connector({
  actions: {
    usageTrackSignupButtonTap,
  },
})(SignupButton);
